import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IFeatureFlag, IFeatureFlagState } from './types';
import { IThunkAPI } from '@/store/types';
import { featureFlagApi } from '@/api/featureflags';
import { RootState } from '@/store';

export const initialState: IFeatureFlagState = {
  featureFlags: {} as IFeatureFlag,
};

export const getFeatureFlags = createAsyncThunk<IFeatureFlag, void, IThunkAPI>(
  'get/featureflags',
  async (_, thunkAPI) => {
    try {
      const response = await featureFlagApi.getFeatureFlags();
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const featureFlagsSlice = createSlice({
  name: 'featureFlagState',
  initialState,
  reducers: {
    clearFeatureFlags(state) {
      state.featureFlags = {} as IFeatureFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(getFeatureFlags.fulfilled, (state, action) => {
      state.featureFlags = action.payload;
    });
  },
});

// selectors
export const featureFlags = (state: RootState): IFeatureFlag | null => {
  if (state.featureFlags?.featureFlags) return state.featureFlags?.featureFlags;
  else return null;
};

export default featureFlagsSlice.reducer;
